module.exports = __webpack_public_path__ + "media/images/favicon-16x16-04ae3b94d2b36fa0d9a11880ddd4e318.png";